import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function SourcePhotoButton({ id, label = "Foto Sumber" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button size="sm" variant="outline" className="h-7" onClick={() => setOpen(true)} data-testid={`view-source-photo-${id}`}>
        <Camera className="w-3.5 h-3.5 mr-1" />{label}
      </Button>
      <SourcePhotoDialog id={id} open={open} onOpenChange={setOpen} />
    </>
  );
}

export function SourcePhotoDialog({ id, open, onOpenChange }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (!open || !id) return;
    let blobUrl;
    setErr(null); setUrl(null);
    api.get(`/source-photo/${id}`, { responseType: "blob" })
      .then((r) => { blobUrl = URL.createObjectURL(r.data); setUrl(blobUrl); })
      .catch(() => setErr("Foto sumber tidak tersedia"));
    return () => { if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [open, id]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader><DialogTitle>VIEW SOURCE PHOTO — {id}</DialogTitle></DialogHeader>
        <div className="min-h-[200px] flex items-center justify-center bg-slate-100 rounded-md overflow-hidden" data-testid="source-photo-container">
          {err && <span className="text-sm text-slate-500">{err}</span>}
          {!err && !url && <span className="text-sm text-slate-400">Memuat foto…</span>}
          {url && <img src={url} alt="Foto sumber transaksi" className="max-h-[70vh] w-auto object-contain" data-testid="source-photo-img" />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
